export default {
	URL: 'https://api-letsarapremiacao.infinitum-ti.com',
	API_URL: 'https://api-letsarapremiacao.infinitum-ti.com/api',
	OAPI_URL: 'https://api-letsarapremiacao.infinitum-ti.com/oapi',
	// URL: 'http://localhost:2403',
	// API_URL: 'http://localhost:2403/api',
	// OAPI_URL: 'http://localhost:2403/oapi',
}
